import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { RoleKeys } from './role.keys';

export async function getRoles() {
  return clients.admin
    .get(`/roles`)
    .then((response: AxiosResponse<string[]>) => response.data as string[]);
}

export function useGetRoles() {
  return useQuery(RoleKeys.lists(), () => getRoles());
}
